var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgress(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.00244141,
    width: 26,
    height: 26,
    rx: 13,
    fill: "#4F66AA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5293_15068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.74756 7.75C7.74756 7.26602 7.35654 6.875 6.87256 6.875C6.38857 6.875 5.99756 7.26602 5.99756 7.75V16.9375C5.99756 18.1461 6.97646 19.125 8.18506 19.125H19.1226C19.6065 19.125 19.9976 18.734 19.9976 18.25C19.9976 17.766 19.6065 17.375 19.1226 17.375H8.18506C7.94443 17.375 7.74756 17.1781 7.74756 16.9375V7.75ZM18.8655 10.118C19.2073 9.77617 19.2073 9.22109 18.8655 8.8793C18.5237 8.5375 17.9687 8.5375 17.6269 8.8793L14.7476 11.7613L13.178 10.1918C12.8362 9.85 12.2812 9.85 11.9394 10.1918L8.87686 13.2543C8.53506 13.5961 8.53506 14.1512 8.87686 14.493C9.21865 14.8348 9.77373 14.8348 10.1155 14.493L12.5601 12.0512L14.1296 13.6207C14.4714 13.9625 15.0265 13.9625 15.3683 13.6207L18.8683 10.1207L18.8655 10.118Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5293_15068"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5.99756 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress);
export default __webpack_public_path__ + "static/media/progress.0ec3505d48d5ace1bac1c47d01bbb42d.svg";
export { ForwardRef as ReactComponent };